import { render, staticRenderFns } from "./ToolboxWidget.vue?vue&type=template&id=43055a75&scoped=true"
import script from "./ToolboxWidget.vue?vue&type=script&lang=js"
export * from "./ToolboxWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43055a75",
  null
  
)

export default component.exports